import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import {
  DEFAULT_ACCEPT_LANGUAGE,
  isServer,
  redirectToAccessRestricted,
  refreshPage,
} from '../utils/misc'

export interface InterceptorConfig {
  redirectToAccessRestricted?: boolean
}

export interface AdditionalRequestConfig {
  baseUrl?: string
  headers?: { [key: string]: string }
}

axios.interceptors.request.use(function (config) {
  if (!isServer()) {
    config['headers']['Accept-Language'] = [
      // Navigator is not defined when this code is run server side
      // eslint-disable-next-line
      // @ts-ignore
      ...(navigator?.language ? [navigator.language] : []),
      DEFAULT_ACCEPT_LANGUAGE,
    ].join(', ')
  }
  return config
})

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (401 === error?.response?.status) {
      // A better way could be to trigger auth0 to receive new token instead of refreshing the page
      refreshPage()
    } else if (
      403 === error?.response?.status &&
      error.response.config.redirectToAccessRestricted
    ) {
      redirectToAccessRestricted()
    } else {
      return Promise.reject(error)
    }
  },
)

export const request = async <T>(
  config: AxiosRequestConfig & InterceptorConfig,
) =>
  (await axios(Object.assign({ timeout: 10000 }, config))) as AxiosResponse<T>
